module.exports = {
  Route: 'Region',
  Level: 'Tier',
  POL: 'POL',
  POD: 'POD',
  PODCountry: 'POD Country(Area)',
  TransferPort: 'TransferPort',
  Remarks: 'Remarks',
  COL: 'COL',
  COD: 'COD',
  ROL: 'ROL',
  ROD: 'ROD',
  Direct: 'Direct',
  TSport: 'T/S port',
  Via: 'VIA',
  ServiceMode: 'Service Mode',
  EqType: 'Container Type',
  EqSize: 'TYPE',
  Currency: 'Currency',
  PaymentTerm: 'Payment Term',
  Carrier: 'Carrier',
  DepartureDay: 'Frequency',
  DepartureDayOfAir: 'Frequency',
  DepartureDayOfAir2: 'Freq.of 2nd Leg',
  CargoAircraft2: 'Model Of 2nd Leg',
  AircraftOrFreighter: 'PASSENGER FLIGHT/CARGO FREIGHTER',
  FreighterOrAircraft: 'CARGO FREIGHTER/PASSENGER FLIGHT',
  AirlinerNB: 'CARGO FREIGHTER(NB)',
  ClosingDay: 'Closing Day',
  Days: 'T/T',
  DaysColSea: 'T/T(D)',
  DaysUnitSea: 'T/T(D)',
  Commodity: 'Commodity',
  ServiceCode: 'Service Code',
  BeginDate: 'Valid From',
  EndDate: 'To',
  EndDateAlign: 'left',
  BeginDateCol: 'Valid From',
  EndDateCol: 'Valid To',
  Fees: 'Charges',
  Sum: 'Sum',
  Amount: 'Amount',
  Save: 'SAVE',
  Cancel: 'CANCEL',
  GreaterThanZero: 'The value must greater than 0.',
  Error: 'Error',
  Tips: 'Tips',
  Warning: 'Warning',
  SelectRoute: 'You should select the region!',
  SelectTerm: 'You should select the payment term!',
  CompareValidate: 'The Validate is invalid.',
  FreeTimeType: 'Type of no-container period',
  PleaseInput: 'Please enter a value for the {0}.',
  NeedFreeBox: 'The free box is mixed {0} days',
  FreeTimeCalculatedSeparately: 'The stack-free period is {0} days, and the container-free period is {1} days',
  DaysValidate: 'Days is Not Empty.',
  SavedSucceed: 'Saved succeed.',
  ApplyAgree: 'Apply agreed.',
  ApplyRefuse: 'Apply refused.',
  CancelAgreed: 'Cancel Agreed.',
  Canceled: 'Canceled',
  CurrentPriceEditSucceed: 'The price have changed the state as pending price, you should approve it once again.',
  ErrorRaised: 'Error raised.',
  HasApproved: 'Approved.',
  HasDeleted: 'Deleted.',
  IsApproveRecord: 'Are you sure you want to approve this price?',
  IsApproveRecords: 'Are you sure you want to approve these prices?',
  IsDeleteRecord: 'Are you sure you want to delete this record?',
  IsDeleteRecords: 'Are you sure you want to delete all selected records?',
  NoRecordSelect: 'No record is selected.',
  UploadSucceed: 'Upload Succeed.',
  UploadFailed: 'Upload Failed.',
  Agree: 'AGREE',
  Refuse: 'REFUSE',
  CancelAgree: 'CANCEL AGREE',
  Edit: 'EDIT',
  Delete: 'DELETE',
  Approve: 'APPROVE',
  Add: 'ADD',
  Query: 'QUERY',
  Reset: 'RESET',
  Import: 'Import From Excel',
  GeekYumImport: 'Import From Geek Yum Excel',
  OneStackImport: 'Import From One Stack Excel',
  Export: 'Export to Excel',
  Template: 'Download Template',
  ExportPDF: 'Export to PDF',
  PendingPrice: 'Pending Price',
  CurrentPrice: 'Effective Price',
  WrongInput: 'The value is invalid. Please correct it and try again.',
  EtaMustBeLaterThanOrEqualToEtd: 'ETA must be later than or equal to ETD',
  POLIsNull: 'POL is invalid. Please correct it and try again.',
  PODIsNull: 'POD is invalid. Please correct it and try again.',
  PortPrompt: 'Input the Seaport',
  PriceNoPrompt: 'Input the Price No.',
  PriceNoIsNull: 'PriceNo is invalid. Please correct it and try again.',
  POLPrompt: 'Input the POL',
  POLPrompt2: 'Input the POD',
  PODPrompt: 'Input the POD',
  CountryPrompt: 'Input the Country or Area',
  COLPrompt: 'Input the Country or Area',
  CODPrompt: 'Input the Country or Area',
  CODAirPrompt: 'Please enter the destination country or region',
  FeeFclPrompt: 'Input the Charge',
  NoRecord: 'No record.',
  PleaseSelectTheExpirationDateFirst: 'Please select the expiration date first',
  EitherETDOrValidityPeriodMustBeFilledIn: 'Either ETD or validity period must be filled in',
  TariffTableExportLevelTitleTips: 'Export tariff tips',
  TariffTableExportLevelTips: 'The fare for 【fare class: {0}】 is currently being exported.',
  theSelectedValidityPeriodCannotExceed3Months: 'The selected validity period cannot exceed 3 months',
  theSelectedETDCannotExceed3Months: 'The selected ETD period cannot exceed 3 months',
  NoRecordUpload: 'The document does not have any price data for uploading.',
  QueryRecords: '{0} record(s).',
  selectedCount: 'You have select {0} record(s).',
  MustDifferent: '{0} is not allowed to be the same with {1}.',
  ModifiedBy: 'Modified By',
  ModifiedDate: 'Modified Date',
  ApprovedBy: 'Approved By',
  ApprovedDate: 'Approved Date',
  NotAllowedDelete: 'You are only allowed to delete the price created by yourself.',
  IsAllowedOperate: 'You are not allowed to approve or delete the price that POL is {0} and POD is {1}.',
  IsAllowedOperate_DiffBranch: 'You are not allowed to operate the price that is upload by other company.',
  Mon: 'MON',
  Tue: 'TUE',
  Wed: 'WED',
  Thu: 'THU',
  Fri: 'FRI',
  Sat: 'SAT',
  Sun: 'SUN',
  NotAllowed: 'You are not allowed to query the price of this tier.',
  NotAllowedInput: 'You are not allowed to add the POL.',
  NotAllowedFromCountry: 'You are not allowed to query the price from this country.',
  NotAllowedFromRegion: 'You are not allowed to query the price from this region.',
  NotAllowedToCountry: 'You are not allowed to query the price to this country.',
  NotAllowedToRegion: 'You are not allowed to query the price to this region.',
  NotAllowedPOD: 'You are not allowed to query the price of this POD.',
  NotAllowedPOL: 'You are not allowed to query the price of this POL',
  NotAllowedPOD2: 'You are not allowed to query the price of this POD({0}).',
  NotAllowedPOL2: 'You are not allowed to query the price of this POL({0})',
  Origin: 'Origin',
  Dest: 'Dest.',
  NStep: 'N',
  Flight: 'Service Item',
  Aircraft: 'Aircraft',
  AircraftFullName: 'Aircraft Full Name',
  MinCharge: 'MINIMUM',
  Carrier_Air: 'Carrier',
  Agent: 'Booking Agent',
  PleaseSelectBookingAgent: 'Select Booking Agent',
  resetDataGrid: 'reset',
  MaxQueryCount: 'Max records limit reached, pls narrow your search to see more results.',
  MaxQueryCount2: 'First {0} records are retrieved, click \'Enough\' to show the results or \'More\' to continue searching, the max amount is 10000, pls narrow your search.',
  CreatedBy: 'Created By',
  CreatedDate: 'Created Date',
  ContractNo: 'Contract No.',
  Big: 'Zoom In',
  Small: 'Zoom Out',
  CONFIRM: 'CONFIRM',
  OK: 'OK',
  CANCEL: 'CANCEL',
  DifferentCarrier: 'The carriers are different.Are you sure you want to approve these prices?',
  DifferentRegion: 'The {0} is different.Are you sure you want to approve these prices?',
  DifferentCarrierAndRegion: 'The prices have different carrier and {0}.Are you sure you want to approve these prices?',
  DifferentCarrierAndRegions: 'The prices have different carrier, ROL and ROD.Are you sure you want to approve these prices?',
  NotAllowedDifferentRegions: 'Not allowed to approve for the {0} is different.',
  NotAllowedDifferentCarrierAndRegion: 'Not allowed to approve for different carriers and {0}.',
  NotAllowedDifferentCarrierAndRegions: 'Not allowed to approve for different carriers, ROL and ROD.',
  NetConnectionFailed: 'The server is no response,pls check the net connection and try it later.',
  FaultCode: 'Error Code:',
  FaultMessage: 'Message:',
  Branch: 'Branch',
  COMMON_ERROR: 'Row {0}, {1} is invalid.<br/>',
  RATE_TYPE_ERROR: '\tRow {0}, {1} is invalid.\nThis warning is showed on the occasion as follows:\n 1:The rate in the excel is not the right rate type;\n2.The excel template on server has updated;\n',
  IS_EMPTY: '\tRow {0},{1} is empty.\n',
  EXIST_THE_SAME_TIME: '\tRow {0},The number of  {1} and {2} must exist  is different.\n',
  REGION_NO_POL: '\tRow {0}, the region of POL is {1} and not same with the ROL in the sheet of Excel.\n',
  REGION_NO_POD: '\tRow {0}, the region of POD is {1} and not same with the ROD in the sheet of Excel.\n',
  EQ_TYPE_SIZE: '\tRow(s) and column(s) is(are) {0}, the EQ {1} is invalid.\n',
  CHARGES: '\tRow {0}, {1} of {2} is invalid.\n',
  SUM_NOT_EQUAL: '\tRow {0}, the SUM of {1} is not equal to the sum of charges.\n',
  NO_OF: '\tRow {0}, can not find the OF of {1}.\n',
  NO_SUM: '\tRow {0}, SUM of {1} is invalid.\n',
  IS_SAME: '\tRow {0}, {1} must different with {2}.\n',
  BOTH_EMPTY: '\tRow {0}, Both {0} and {1} are empty.',
  FIELD_TOO_LONG: '\tRow {0}, the {1} too long, the max length allowed is {2}.\n',
  NO_CONFIGURATION_CHARGES: '\tThere is no configuration {0}, pls contact us.\n',
  EMPTY_DATATABLE: '\tThere is(are) no data of {0}, pls contact us.\n',
  NOT_ALLOWED_UPLOAD: '\tThe tier of "{0}" is not allowed to upload.\n',
  NO_FIELD: '\tThere count not find {0}.\n',
  VALIDITY_ERROR: '\tRow {0}, {1}  can not exceed two months from now on.\n',
  VALIDITY_LESS: '\tRow {0}, the \'{1}\' must after the \'Valid fm\'.',
  NOT_ALLOWED_NEGATIVE: '\tRow {0}, {1} must bigger than or equal to 0;\n',
  IS_LESS: '\tRow {0}, {1} must bigger than or equal to {2}.\n',
  MUST_EMPTY: '\tRow {0}, according to {2}\'s value, {1} should be set empty.\n',
  EXISTS_SAME_TIME: '\tRow {0}, {1} and {2} are not allowed input at the same time.\n',
  FORMAT_NOT_MATCHING: '\tRow {0}, {1} is not matching.\n',
  Records: '{1} record(s) of "{0}",',
  LoadSucceed: 'have been uploaded successfully.\n',
  Chk: '\u3010Checkbox\u3011',
  Detail: '\u3010Detail\u3011',
  CustomConfig: 'Custom...',
  DataGridConfig: 'Configuration of Columns',
  Close: 'CLOSE',
  Visible: 'Visible',
  ColumnName: 'Column Name',
  Three_BE_Two: 'The price of tier 3 must bigger than or equal to tier 2.',
  Three_B_One: 'The price of tier 3 must bigger than tier 1.',
  Two_B_One: 'The price of tier 2 must bigger than tier 1.',
  Three_BE_One: 'The price of tier 3 must bigger than or equal to tier 1.',
  Two_BE_One: 'The price of tier 2 must bigger than or equal to tier 1.',
  Details: 'Details',
  RateDetails: 'Rate Details',
  ScheduleDetails: 'Sailing Schedule',
  ClickMe: 'Click me to change query mode.',
  ClickMeSimple: 'Click me to change query mode.\nThe Simple Query Mode will query the price valid from today.',
  SubmittedBy: 'Submitted By',
  SubmittedDate: 'Submitted Date',
  ShippingLine: 'Outport Code',
  PlsSelect: 'PLEASE SELECT',
  PlsSelectValue: 'Pls select a value.',
  InputValue: 'Pls input a value.',
  PriceDateType: 'PriceDateType',
  volumeWeightRatio: 'Volume to weight ratio',
  minRateValue: 'Minimum billing unit',
  PleaseNumber: 'Please fill in the number',
  M: 'M',
  F: 'F',
  PODCodeChanged: 'The price may be invalid as its POD code does not exist in the system!',
  Week: 'This Week',
  Month: 'Month',
  Statistics: 'STAT',
  State: 'State',
  StatBeginDate: 'Period',
  StatBeginDateByDate: 'Entry Time',
  StatBeginDateByPort: 'Validity Period',
  StatEndDate: 'To',
  ByState: 'State',
  ByDate: 'Period',
  ByPort: 'Seaport',
  StatSucceed: 'Succeed.',
  TotalAmount: 'Amount',
  FCLStatistics: 'FCLStatistics',
  AirStatistics: 'AirStatistics',
  Prepaid: 'PP',
  Collect: 'CC',
  Both: 'P/C',
  ApproveAsync: 'Do you want the task to run at backend?',
  TariffRatingAtTheTimeOfMaintenance: 'Define the tariff class',
  TaskStart: 'The task is start on the backebd.',
  ExceedMaxAmount: '300 records is the max amount allowed to approve prices when you cancel the select of run at backend.',
  YesLabel: 'Enough',
  NoLabel: 'More',
  Yes: 'Yes',
  No: 'No',
  RemarkAreaToolTip: 'Double click here will room in to view the remark detail,double click again will change to normal.',
  ApproveSet: 'Approve Settings',
  ALLRG: 'All Regions',
  Back: 'BACK',
  CopySetting: 'Copy Setting',
  PasteSetting: 'Paste Setting',
  NoSettingSelect: 'Pls select a record.',
  NoSetting: 'No setting of PFMarkupSetting.',
  SettingNoRegion: 'The record selected is no {0}.',
  SettingNoEQ: 'The record selected is no EQ.',
  SettingOverlap: 'The records selected exist overlap.',
  NotSave: 'The operation have not saved, do you want to save it?',
  Refresh: 'REFRESH',
  Search: 'Filter',
  AuthInvite: 'Invite',
  AuthAccept: 'Accept',
  AuthInvite2: 'Price Share',
  AuthAccept2: 'Price Apply',
  Source: 'Source',
  PlsInputCode: 'Pls input the code or full name of the tenant you want share with.',
  ShareWithMyself: 'It is the company you worked in.',
  DuplicateShare: 'You have shared your price with {0}.',
  NoHit: 'There is no record meet your input.',
  ReallyWantAccept: 'Are you want to accept the invite of {0}?',
  ReallyWantShare: 'Are you want to share price with {0}?',
  ReallyWantRefuse: 'Are you want to refuse the apply of {0}?',
  ReallyWantAgree: 'Are you want to agree the apply of {0}?',
  NoTierChange: 'The tier is no change.',
  ReallyWantChange: 'Are you really want to change the tier to {0}?',
  ReallyWantCancelShare: 'Are you really want to cancel the share with {0}?',
  ReallyWantCancelAccept: 'Are you really lost interest in {0}\'s shares?',
  Accepted: 'Accepted',
  NotAccepted: 'Not Accepted',
  NotCheck: 'Not Checked',
  Agreed: 'Agreed',
  Refused: 'Refused',
  AllState: 'ALL',
  ShareState: 'State',
  Accept: 'ACCEPT',
  Check: 'CHECK',
  ShareRemark: 'Remark',
  ShareRemarks: '\u203BSharing notes are visible on both sides',
  RefuseRemark: 'RefuseRemark',
  AcceptTenant: 'Accept Party',
  AcceptTime: 'Accept Date',
  InviteTenant: 'Invite Party',
  inviteTime: 'Invite Date',
  AcceptUser: 'Who Accept',
  InviteUser: 'Who Invite',
  IWantShare: 'I want to share price with',
  WantApply: 'want to Apply price with',
  AllowedTier: 'The tier is',
  NotRequired: 'Default',
  CargoAircraft: 'CARGO FREIGHTER',
  Airliner: 'PASSENGER FLIGHT',
  HeadLiftAircraft: 'Head lift aircraft',
  Subscribe: 'Subscribe to rate updates by various stations',
  PlsSubscribe: 'Price Subscription Services will enable you to get e-mail notice once the rates are updated. Personal configuration is available as below:',
  PlsSetEmail: 'Enter the mail address you would like to receive the notice.',
  PlsSelectOffice: 'Your preference on rate update of branch office level.',
  PlsSelectTenant: 'Your preference on rate update of partner level.',
  Email: 'Email',
  IsActive: 'Active',
  Subscriber: 'Subscriber',
  SubscribeCondition: 'Condition',
  SubscribeFromTenant: 'The tenant of subscriber',
  DuplicateFees: 'There are more than one record of {0} fee.',
  AddFee: 'Add charge',
  DelFee: 'Delete the charge',
  DecodeMarkupFailed: 'Failed to decode FCL markup settings, pls contact system administrator or HQ manager.',
  ROD_EQ: 'ROD or EQ',
  WeightPrice: 'Weight Price',
  VolumePrice: 'Volume Price',
  MinimumPrice: 'Minimum Price',
  WeightCost: 'Weight Cost',
  VolumeCost: 'Volume Cost',
  PODCharge: 'POD Charge',
  Coloader: 'Coloader',
  DirectCustomer: 'Direct Customer',
  TradeLane: 'TradeLane',
  FeeIndex: 'Fee Index',
  FeeName: 'Fee Name',
  FeeUnit: 'Fee Unit',
  CostRate: 'Cost(Rate)',
  CostMin: 'Cost(Min)',
  ColoaderRate: 'Coloader(Rate)',
  ColoaderMin: 'Coloader(Min)',
  CustomerRate: 'Customer(Rate)',
  CustomerMin: 'Customer(Min)',
  FeeRate: 'Fee(Rate)',
  FeeMin: 'Fee(Min)',
  CurrentTenant: 'My Company',
  BadDays: 'The T/T is invalid.',
  NotSameLength: 'The count of {0} and {1} is not equal.',
  NoPODCharge: 'No Pod Charge founded.',
  TenantPrompt: 'Pls Input Tenant',
  MoreSetting: 'More',
  PlsConfigDetail: 'Pls setting more.',
  SubscribeType: 'Type',
  SubscribePOL: 'Place of Loading',
  SubscribePOD: 'Place of Discharge',
  NoTax: 'ALL RATES ARE SUBJECT TO VAT.',
  CheckApproveSet: 'Approve Overtime Settings',
  StartTime: 'Start At',
  EndTime: 'End At',
  CheckInterval: 'Check Interval',
  Hour: 'o\'clock',
  Hours: 'hour(s)',
  Times: 'per day',
  MaxMailPerDay: 'Send mails max',
  KPIEmail: 'Receiver of KPI Report',
  CompareTime: 'The Start Time must less than the End time.',
  Lane: 'Lane Code',
  PlsInput: 'Pls input the {0}.',
  ClientName: 'Name',
  Owner: 'Owner',
  PlsInputQuotationNo: 'Pls Input quotation No.',
  Quotation: 'Quotation Lists',
  QuotationNo: 'Quotation No.',
  Client: 'Customer',
  Sales: 'Sales',
  QuotationDate: 'Quotation Date',
  NoChargeAndPrice: 'Pls input the price or charge.',
  IsMarkup: 'Are you sure you want to markup the price?',
  BasicInfo: 'Basic',
  PriceInfo: 'Rate',
  ChargeOfReceiptPlace: 'POL Charge',
  ChargeOfDeliveryPlace: 'POD Charge',
  PlsInputRemark: 'For remarks.',
  NewRate: 'New Rate',
  DelRate: 'Del Rate',
  MarkupRate: 'Markup Rate',
  QuotationClient: 'Client of Quotation',
  RefreshFinished: 'Finished.',
  Contact: 'Contact',
  Phone: 'Phone',
  Fax: 'Fax',
  Address: 'Address',
  PlsInputUserInfo: 'Pls input all your contact information.',
  DifferentPOL: 'The POL are different, whether to continue?',
  DifferentPOD: 'The POD are different, whether to continue?',
  View: 'VIEW',
  PlaceOfReceipt: 'Place of Receipt',
  PlaceOfDelivery: 'Place of Delivery',
  Goods: 'Commodity',
  Weight: 'Weight(KG)',
  Weight_LCL: 'REV/Ton',
  Volume: 'Volume',
  Measurement: 'Dims',
  ChargedWeight: 'Charged Weight',
  FreightTerm: 'Term',
  GoodsLevel: 'Goods Level',
  Hazard: 'Hazard',
  QuotationValidFrom: 'Valid From',
  PlsInputClient: 'Client is invalid. Please correct it and try again.',
  NotQuotationToOthers: 'Pls not quotation to other sales\'s client.',
  FeeNameIsNull: 'Fee name is invalid. Please correct it and try again.',
  FeeUnitIsNull: 'Fee Unit is invalid. Please correct it and try again.',
  ValidityCfgLoadError: 'Error raised when load the FCL validity configure data.',
  ExportMode: 'Click \'Standard\' will export the columns with order you see on the page exactly; click \'Customization\' will export specific format designed by the system manager.',
  WYSIWYG: 'Standard',
  ExportByTemplate: 'Customization',
  RateValidation: 'Rate Validation',
  ContinueApprove: 'CONTINUE',
  AbnormalDetected: 'The pending rates may have below conflicts with system rules. For details, pls click the blue titles.',
  SumAbnormal: 'Sum up rates abnormal detected.',
  EQAbnormal: 'Abnormal rates detected for different EQ type under same conditions.',
  PlaceAbnormal: 'Abnormal rates detected for same POL, POD with same EQ type.',
  ValidAbnormal: 'Valid period abnormal detected.',
  AlertSumAbnormal: 'Pls set the condition of sum up abnormal.',
  AlertEQAbnormal: 'Pls set the condition of abnormal rates for different EQ type under same conditions.',
  AlertPlaceAbnormal: 'Pls set the condition of abnormal rates for same POL, POD with same EQ type.',
  AlertValidAbnormal: 'Pls set the condition of valid period abnormal.',
  AddCondition: 'Add Condition',
  ErrorCfg: 'The configuation is invalid.',
  SettingDuplicate: 'The setting is already exists.',
  EQMustDifferent: 'The EQ type must different.',
  ExistLoop: 'A loop is detected among the settings.',
  PriceSetting: 'Setting',
  Markup: 'Markup',
  Validation: 'Validation',
  OvertimeApprove: 'Approve Reminder',
  PlsChangeSystemCfg: 'Please change the default configuration in the system configuration page, enable the desired settings.',
  NeedMarkupCfg: '1 is generate rate of more than one tier,0 only generate one tier,',
  NeedCheckValidityCfg: '1 is check the validation of rate before approve,0 is not.',
  NeedCheckApproveCfg: '1 is reminder when rate was uploaded hours ago,0 is no reminder.',
  Wrong: 'Wrong',
  Day: 'Day',
  DeleteCfg: 'Delete the setting',
  Setting: 'SETTING',
  Print: 'PRINT',
  ClientExist: 'The client is already exists.',
  SaveQuotation: 'Pls save the quotation.',
  FileHistory: 'File History',
  ShippingSchedule: 'Shipping Schedule',
  PlsInputPOLPOD: 'Pls input the POL and POD in \'Basic\' Page.',
  ChargeName: 'Charge Name',
  Rate: 'Rate',
  RateByCost: 'Cost Rate',
  ChargeUnit: 'Charge Unit',
  CopyQuotation: 'Copy Quotation',
  PasteQuotation: 'Paste Quotation',
  Copy: 'COPY',
  IsCopy: 'Are want to copy the selected quotation?',
  NotAllowedCopy: 'You are not only allowed to copy quotation created by others.',
  PlsSelectRecord: 'Pls select a record.',
  PlsInputPersonalInfo: 'The contact and phone of customer is empty.',
  AddNewCustomer: 'Add new customer',
  Cost20: '20\' Cost',
  Cost40: '40\' Cost',
  CostHC: '40\'HC Cost',
  Cost45: '45\' Cost',
  FCL: 'FCL Rate',
  LCL: 'LCL Rate',
  Air: 'Air Rate',
  Num20: '20\' Amount',
  Num40: '40\' Amount',
  NumHC: '40\'HC Amount',
  Num45: '45\' Amount',
  Num: 'Amount',
  EffectiveDate: 'Effective Date',
  ExpirationDate: 'Expiration Date',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  BookingAgent: 'Booking Agent',
  COST_VAT: 'VAT(Cost)',
  SELL_VAT: 'VAT(Sell)',
  VatInvalid: 'Sell vat is invalid, it is less than cost vat.',
  MinimumInvalidLCL: 'Minimum is invalid, it is greater than weight or volume price.',
  VAT: 'VAT',
  Dock: 'Dock',
  PriceNo: 'Price No.',
  Self: 'Self',
  Share: 'Share',
  Suspend: 'SUSPEND',
  PriceTrend: 'Trends',
  Rise: 'Rise',
  Fair: 'Fair',
  Fall: 'Fall',
  CabinNature: 'Cabin Nature',
  Dockland: 'Dockland',
  ShareCarriers: 'Share Cabin',
  BillType: 'Bill Type',
  ShippingClause: 'Shipping Clause',
  VatIncluded: 'Vat Included',
  ChargeType: 'Charge Type',
  UnitPrice: 'Unit Price',
  RouteAndPODEmpty: 'Both Trade lane and POD are empty.',
  RouteAndPODEmpty1: 'Please ensure that at least one has been typed in for the POL, POD, Route, Carrier, and booking agent.',
  RouteAndPODEmpty2: 'Please ensure that at least one has been typed in for the POL, POD, Route.',
  Surcharge: 'Surcharge',
  LocalCharge: 'Local Charge',
  DesCharge: 'Destination Charge',
  WeightRule: 'Rule',
  Invalid: 'INVALID',
  SchemeAudit: 'Scheme Approve',
  ManualAudit: 'Manual Approve',
  ECommerceFareOfflineReminder: 'E-commerce fare offline reminder',
  ECommerceFareOfflineReminderContent: 'When the e-commerce freight rate of the relevant shipping company is approved, the previously released e-commerce freight rate will be taken offline, and the e-commerce freight rate approved by this batch will be the only e-commerce freight rate issued by the same shipping company.',
  PleaseSelectDataForTheSameTariffType: 'Please select data for the same tariff type',
  Finished: 'Finished',
  InvalidSelection: 'Do you want to set the selection to invalid state?',
  SuspendSelection: 'Do you want to set the selection to {0} state?',
  DetailOfFCL: 'FCL Detail',
  DetailOfLCL: 'LCL Detail',
  WeightLimitLoadFailed: 'The weight limit information of FCL load failed!',
  ExtraLoadFailed: 'The extra information of FCL load failed!',
  SurchargeLoadFailed: 'The surcharge of FCL load failed!',
  WeightLimitInfo: 'Weight limit information of FCL',
  ExtraInfo: 'Extra information of FCL',
  ScheduleInfo: 'Sailing schedule information of FCL',
  Audit: 'Audit Price',
  POLs: 'POLs',
  PODs: 'PODs',
  Port: 'Seaport',
  Code: 'Code',
  ChineseName: 'Chinese Name',
  EnglishName: 'English Name',
  Country: 'Country',
  Region: 'Region',
  Find: 'FIND',
  RegionOrCarrier: 'Region or Carrier',
  ALL: 'ALL',
  Cost: 'Cost',
  Sell: 'Sell',
  Invalid20: 'The sell of 20\' rate is lower than cost.',
  Invalid40: 'The sell of 40\' rate is lower than cost.',
  HCInvalid: 'The sell of 40\'HC rate is lower than cost.',
  Invalid45: 'The sell of 45\' rate is lower than cost.',
  CasePriceInvalid: 'The sell rate of case price is lower than cost.',
  ALLINRemarks: 'Remarks: surcharge of gray background are included in ALL IN rate.',
  EXISTS_SAME_TIME2: '{0} and {1} are not allowed input at the same time.',
  NotAuth: 'You are not allowed to view the detail.',
  HiddenCost: 'You are not allowed to view other branch\'s cost.',
  Next: 'NEXT',
  SuspendRate: 'Rate of gray background color is in suspend state.',
  RejectRate: 'Rate with line through is in reject state.',
  InactiveRate: 'Rate of strike-through is in inactive state.',
  RemoteBooking: 'REMOTE BOOKING',
  ECommerceRemarks: 'E-commerce price remarks',
  TraditionalRemarks: 'Offline price notes',
  CopyPriceNo: 'Copy Price No.',
  NoExchangeRate: 'The exchange rate of {0} is not maintain.',
  NoSurcharge: 'Charge Item of {0} is not maintain.',
  AuthorizedClient: 'Client',
  ClientIsEmpty: 'The client is empty.',
  PlsSelectRule: 'Pls select a markup rule.',
  PriceLoadFailed: 'Failed to load rate.',
  ALLINIncludes: 'ALL IN includes surcharges as follows:',
  PlsSelectOF: 'Pls select a rate as ocean freight.',
  CostPrice: 'Cost Price',
  ColoaderPrice: 'Coloader Price',
  CustomerPrice: 'Customer Price',
  MarketPrice: 'Market Price',
  PriceState: 'Rate Status',
  PriceState_Common: 'Common',
  PriceState_Suspend: 'Suspend',
  PriceState_Reject: 'Reject',
  PriceState_Inquiry: 'Inquiry',
  PriceState_Lack: 'Lack',
  PriceState_Overbooked: 'Overbooked',
  PlsSelectRejectEQ: 'Pls check the container type of reject rate.',
  RateGrade: 'Rate Grade',
  MarkupBy: 'Markup By',
  MarkupTo: 'Markup To',
  MarkupType: 'Markup Type',
  CabinState: 'Cabin State',
  LatestTemplateVersion: 'The latest version of template is {0}',
  SpecialPrice: 'SALE',
  OtherInfo: 'Other Info',
  FreeContainerPeriod: 'Free container period',
  FreeTime: 'Free Time',
  GroupNo: 'Group No',
  SaleState: 'Sale State',
  GenerateCharge: 'Generate Charge',
  Attachment: 'Attachment',
  EffectiveDateType: 'Effective DateType',
  ExpirationDateType: 'Expiration DateType',
  ReceivingInstructions: 'Receiving Instructions',
  ReceivingType: 'ReceivingType',
  quantity: 'quantity',
  amsEns: 'AMS/ENS',
  overloadRemarks: 'Overload Remarks',
  PodRegion: 'Destination port area',
  Dangerous: 'Dangerous',
  DangerousClass: 'Dangerous Class',
  UnNo: 'UNNO',
  City: 'City',
  POLCity: 'POL City',
  PODCity: 'POD City',
  POLCityPrompt: 'Input the POL City',
  PODCityPrompt: 'Input the POD City',
  DepartureDay2: 'Frequency2',
  jobTypeExport: 'Export',
  jobTypeImport: 'Import',
  BusinessType: 'Business type',
  IsBooked: 'Booking order Created',
  FileName: 'FileName',
  DocumentId: 'DocumentId',
  DocumentCategory: 'DocumentCategory',
  FileSize: 'FileSize',
  Common: 'Common',
  BasicPort: 'Basic Port',
  ECommerceEta: 'E-commerce ETA',
  ECommerceEtd: 'E-commerce ETD',
  AcceptTenant2: 'Accept Party',
  AcceptUser2: 'Who Accept',
  AcceptTime2: 'Accept Date',
  InviteTenant2: 'Invite Party',
  InviteUser2: 'Who Invite',
  inviteTime2: 'Invite Date',
  customSpecs: 'Custom Specs',
  reject: 'Reject',
  fclRateSearch: 'FCL Rate Search',
  onlyViewAndEditCostAreAllow: 'Only viewing and editing cost shipping prices are allowed.',
  SubscribePOLType: 'Place Type of Loading',
  DestinationType: 'Place Type Of Destination',
  Destination: 'Destination',
  OtherCharge: 'Other Charge',
  priceNoPrompt: 'Please enter the price number or the last 7 digits.',
  polOrPodOrRegionOneMustBeEntered: 'POL OR POD OR region one must be entered',
  costAndSumInvalidSave: 'sell is lower than cost! continue to save',
  pleaseChooseOtherOfficeData: 'No data was selected, or other branch data were selected.',
  noSelectedPrice: 'No choice of price.',
  BelongingCity: 'Belonging City',
  UpdateQuotationValidity: 'Update the expiry date of quotation validity period by freight rate validity period?',
  CheckQuotationDeleteTip: 'Quotations with generated orders cannot be deleted!',
  PlsSelectAirOF: 'Please select a freight rate as the air freight.',
  NotMatchChargeItem: 'there is no matching charge name ({0}), please maintain the platform code [{1}] in the charge item module!',
  AirFreight: 'Air Freight',
  WarExpenses: 'War Expenses',
  FuelSurcharge: 'Fuel Surcharge',
  WarehousingFee: 'Warehousing Fee',
  SeaFreight: 'Sea Freight',
  QuotationWeightAndCubageLessZero: 'The weight and volume of the quotation cannot be less than 0!',
  Name: 'Name ',
  MatchType: 'Match Type',
  PriceType: 'Price Type',
  priceNature: 'Nature of freight rate',
  TraditionalFreightRates: 'Traditional Freight Rates',
  Traditional: 'Traditional',
  ECommerce: 'E-commerce',
  SpotFreightRates: 'Spot Freight Rates',
  ConfigureTheSurcharge: 'Configure the surcharge',
  ConfigureTheSurchargeTips: 'You can configure the surcharge that needs to be displayed on the list',
  SpotContainerWeightTips: 'E-commerce freight rate container weight default: 18000KG',
  TariffTableExportExcelTips: 'Due to the amount of data, it is recommended to select the validity period first, and the time span should not exceed 3 months',
  PolCountry: 'Pol Country',
  PolRegion: 'Pol Region',
  PodCountry: 'Pod Country',
  PriceProfile: 'Policy Information',
  SharingProfile: 'Sharing Strategy',
  SelectProfile: 'Selection strategy',
  ViewProfile: 'View Profile',
  PodCity: 'Pod City',
  weightVolume: 'Specific gravity of goods',
  DestinationAgent: 'POD agent',
  warehouse: 'Warehouse',
  WarehouseName: 'Warehouse name',
  WarehouseAddress: 'Warehouse address',
  WarehouseMap: 'Warehouse map',
  warehouseContact: 'warehouse contact',
  FlightInformationManagement: 'Flight Information Management',
  FlightNo: 'Flight No.',
  ClosingTime: 'Deadline',
  DepartureTime: 'departure time',
  ArrivalTime: 'arrival time',
  SizeLimit: 'Size limitations',
  SingletonWeightLimit: 'Single piece weight limit',
  ChemicalPkggReq: 'Chemical Packaging Requirements',
  LithiumBatteryReq: 'Lithium battery demand',
  TimeWarning: 'The arrival time must be greater than the departure time',
  AirDay: 'day',
  flightNumber: 'Flight number cannot be empty',
  emptyTime: 'This is UTC Time.',
  BatchImportQuotations: 'Batch Import Quotations',
  XSuccessfulXFailed: '{0} successful, {1} failed!',
  ErrorVolumeWeightRatio: 'The volume to weight ratio cannot be empty',
  AirPriceServiceItem: 'Import failed. No data has been maintained in the Air Freight Service Item. Please maintain the data first',
  UnNo: 'UN nbr'
}
